export default "__VITE_ASSET__Bu8_KApG__"